<div>
    <app-project-form></app-project-form>
</div>

<div>
    <app-project-list></app-project-list>
</div>